export default __webpack_public_path__ + "img/4c2384a612c0c0df2f62e3fc19a4a11c.png";